module.exports = __webpack_public_path__ + "assets/prevailing-wage.png?94bb4c46d945f0377e11ceab90944f75";